import React from 'react';
import style from './block.module.scss';

function TopPage({image}){
    return <div className={style.block} style={{
    backgroundImage:`linear-gradient(${style.blueBack}40, ${style.blueBack} 35vw),  url(${image})`,}}/>
}

export default TopPage